import React from 'react';
import classNames from 'classnames/bind';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { LazyImg } from '@ifeng-fe/ui_pc_lazyLoad';
import Link, { linkBase } from '@src/mobile/components/Link';
import styles from './index.css';
import { Store } from '../store';
import icon_1 from '@/src/mobile/images/icon_1.png';
import icon_2 from '@/src/mobile/images/icon_2.png';
import icon_3 from '@/src/mobile/images/icon_3.png';
const sortImgList = [icon_1, icon_2, icon_3];

const cx = classNames.bind(styles);

const List = () => {
    const store = Store.useContainer();
    const { states } = store;
    const { list, navHeight, showFixedNav } = states;

    return (
        <>
            <div className={cx('listHead', { listHeadFixed: showFixedNav })} style={{ top: navHeight - 2 }}>
                <div className={styles.row}>
                    <div className={styles.rank}>排名</div>
                    <div className={styles.country}>国家/地区</div>
                    <div className={styles.gold}>金</div>
                    <div className={styles.silver}>银</div>
                    <div className={styles.copper}>铜</div>
                    <div className={styles.sum}>总计</div>
                </div>
            </div>
            <div className={styles.wrap}>
                <div className={styles.listBody}>
                    {list.map((item, index) => {
                        const { country, gold, silver, copper, sum, img } = item;
                        // 是否是前三名
                        const isTopThree = index < 3;
                        // 是否是中国
                        const isChina = country === '中国';

                        const itemInner = (
                            <div className={styles.row}>
                                <div className={cx('rank', { rankTopThree: isTopThree })}>{isTopThree ? <img className={styles.img} src={sortImgList[index]} /> : index + 1}</div>
                                <div className={styles.country}>
                                    <div className={styles.countryFlag}>
                                        <LazyImg src={img} alt="" />
                                    </div>
                                    <div className={styles.countryName}>{country}</div>
                                </div>
                                <div className={styles.gold}>{gold}</div>
                                <div className={styles.silver}>{silver}</div>
                                <div className={styles.copper}>{copper}</div>
                                <div className={styles.sum}>{sum}</div>
                            </div>
                        );

                        return (
                            <div className={isChina ? styles.itemProud : styles.item} key={country}>
                                {itemInner}
                            </div>
                        );
                    })}
                </div>
            </div>
        </>
    );
};

export default errorBoundary(List);
